import React from "react";
import { RCCIcon } from "react-common-components";
import { Body, ContainerWithMargin, DivContent} from "src/components/Card/styles";
import { ISwotItem } from "../../interface";
import Container from "./styles";

const CardSwotMatrix: React.FC<{
	data:ISwotItem,
	onClick?:(tab:"detail"|"bonds")=>void,
	disabled?: boolean
}> = ({
	data,
	onClick,
	disabled = false
}) => (
	<Container disabled={disabled}>
		<ContainerWithMargin color="grey">
			<Body>
				<DivContent 
					style={{ marginLeft: "0.75rem",
						justifyContent:"space-between",
						flexWrap:"nowrap",
						flexDirection:"row"
					}}
					onClick={() => onClick && onClick("detail")} 
				>
					<span>
						{data.dimensionText && 
							<span style={{color:"var(--grey)"}}>[{data.dimensionText}] </span>
						}
						{data.mes002Titulo}
					</span>
					<div>
						{data.hasBonds && 
							<RCCIcon 
								name="shuffle" 
								onClick={() => onClick && onClick("bonds")} 
								style={{
									alignSelf:"flex-end",
									marginRight:"5px",
									cursor: "pointer"
								}}/>
						}
						<span>{data.mes002Pontuacao}</span>
					</div>
				</DivContent>
			</Body>
		</ContainerWithMargin>
	</Container>
);

export default CardSwotMatrix;
